export default __webpack_public_path__ + "static/thebottomline7-6a21a39078e142da756ac6ea6355dca2.jpg";